<template>
  <el-dialog :visible.sync="display" width="30%" @close="closeModal">
    <div>
      <span>{{ $t('socialReviews.modal.respondToReview') }}</span>
      <br>
      <span v-if="currentReview" v-html="drawNote(currentReview.note)" />
      <p v-if="currentReview && currentReview.text !== null">{{ currentReview.text }}</p>
      <p v-else>&nbsp;</p>
      <span v-if="currentReview && currentReview.author !== null">De : {{ currentReview.author}}</span><br><br>
      <el-button type="success" @click="sugestTextIA">{{ $t('socialReviews.modal.respondToIA') }}</el-button><br><br>
      <div class="wait-caption-review-IA" v-if="!waitResponseText && waitText">
        <p>{{ $t('posts.IA.textSpinnerIAReview') }}</p>
        <div><Stretch /></div>
      </div>
      <el-input type="textarea" :rows="6" v-model="text"></el-input>
    </div>
    <span slot="footer" class="dialog-footer">
          <el-button @click="closeModal()">{{ $t("portals.list.cancel") }}</el-button>
          <el-button type="primary" @click="send">{{ $t("portals.list.confirm") }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { mapMutations, mapState } from 'vuex'
import Stretch from '@/components/spinners/Stretch'

export default {
  name: 'SocialReviewAnswerReviewModal',
  components: { Stretch },
  props: [
    'alreadyAnswered'
  ],
  data () {
    return {
      waitText: false
    }
  },
  computed: {
    ...mapState('socialReviewsList', ['modalResponse', 'idReviewToAnswer', 'currentReview', 'textAnswer', 'loadingStatusModal']),
    text: {
      get () {
        return this.$store.getters['socialReviewsList/getTextAnswer']
      },
      set (value) {
        this.$store.commit('socialReviewsList/setTextAnswer', value)
      }
    },
    display: {
      get () {
        return this.$store.getters['socialReviewsList/getModalResponse']
      },
      set (value) {
        this.$store.commit('socialReviewsList/setModalResponse', value)
      }
    },
    waitResponseText () {
      if (this.$store.getters['socialReviewsList/getTextAnswer']) {
        this.waitText = false
      }
      return this.$store.getters['socialReviewsList/getTextAnswer']
    }
  },
  methods: {
    ...mapMutations('socialReviewsList', [
      'setModalResponse',
      'setIdReviewToAnswer',
      'setCurrentReview',
      'setTextAnswer'
    ]),
    closeModal () {
      this.$store.commit('socialReviewsList/setModalResponse', false)
      this.$store.commit('socialReviewsList/setIdReviewToAnswer', null)
    },
    drawNote (note) {
      let strStars = ''
      let i = 1
      for (i; i <= note; i++) {
        strStars = strStars + '&#11088;'
      }
      return strStars
    },
    send () {
      this.$store.dispatch('socialReviewsList/replyToAReview')
      this.$store.commit('socialReviewsList/setIdReviewToAnswer', null)
      this.$store.commit('socialReviewsList/setModalResponse', false)
    },
    sugestTextIA () {
      this.waitText = true
      this.$store.dispatch('socialReviewsList/generateTextIA')
    }
  }
}
</script>

<style scoped>
.wait-caption-review-IA {
  width: 100%;
  line-height: 1.5;
  display: flex;
  flex-direction: column;
  align-items: center;
}
</style>
